/**
 * VOIP Services Index
 * Re-exports all VOIP service functions for easy importing
 */

export {
    initiateVoisoCall,
    initiateCommpeakCall,
    initiateCoperatoCall,
    initiateSquareTalkCall,
    initiateGlobalCallCall,
    initiateBubbleVoipCall,
    getVoisoCallStatus,
    getCommpeakCallStatus,
    getCoperatoCallStatus,
    getSquareTalkCallStatus,
    endCall,
    logCallActivity,
    handleCallCompletion
} from "./voipService";
